module.exports = __webpack_public_path__ + "img/feat-patient-stories.ef94e83a.jpg";